import actionCreator from 'utils/actionCreator';

export const actions = actionCreator('user', [
  'OBSERVE_USER',
  'SIGN_IN_REQUEST',
  'SIGN_IN_GOOGLE_REQUEST',
  'SIGN_IN_SUCCESS',
  'SIGN_UP_REQUEST',
  'SIGN_OUT_REQUEST',
  'SIGN_OUT_SUCCESS',
  'CURRENT_USER_LISTENER',
  'CANCEL_CURRENT_USER_LISTENER',
  'TOGGLE_LOADING',
  'SHOW_ERROR',
  'HIDE_ERROR',
  'UPDATE_PROFILE',
  'UPDATE_PROFILE_SUCCESS',
  'CHANGE_PASSWORD_REQUEST',
  'CHANGE_PASSWORD_SUCCESS',
  // 'RESET_PASSWORD_EMAIL_REQUEST',
  // 'RESET_PASSWORD_EMAIL_SUCCESS',
  'PUSH_NOTIFICATION',
  'SEEN_NOTIFICATION',
  'NOTIFICATIONS_SUCCESS',
  'TOGGLE_NOTIFICATIONS_LOADING',
  'LISTEN_NOTIFICATIONS',
  'CANCEL_LISTEN_NOTIFICATIONS',
  'LISTEN_UNREAD_NOTIFICATIONS',
  'CLEAR_ALL_NOTIFICATIONS',
  'FORGOT_PASSWORD',
  'FORGOT_PASSWORD_UPDATE',
  'VERIFY_PASSWORD_RESET_CODE',
  'USER_ACTION_UPDATE',
  'CONFIRM_PASSWORD_RESET',
  'SEND_FEEDBACK',
  'FEEDBACK_UPDATE',
  'RESEND_VERIFICATION_EMAIL',
  'VERIFY_EMAIL',
  'CONTACT',
  'SIGNUP_UPDATE',
  'SEND_PRO_REQUEST',
  'ONBOARDING_UPDATE',
  'TOGGLE_EMAIL_PREFERENCE',
  'DELETE_USER',
  'TOGGLE_REAUTH',
  'NOTIFICATIONS_OPENED',
  'FETCH_CURRENT_INTEGRATIONS_REQUEST',
  'FETCH_CURRENT_INTEGRATIONS_SUCCESS',
  'SUBSCRIPTIONS_SUCCESS',
  'CANCEL_SUBSCRIPTION',
  'UPDATE_SUBSCRIPTION',
  'BILLING_DETAILS_REQUEST',
  'BILLING_DETAILS_SUCCESS',
  'UNDO_CANCEL_SUBSCRIPTION',
  'TOGGLE_NOTIFICATION_SOUND',
  'RESEND_EMAIL_CHANGE_VERIFY_EMAIL',
  'CANCEL_SUBSCRIPTION_PENDING_UPDATE',
]);

export function observeUser(navigate) {
  return {
    type: actions.OBSERVE_USER,
    navigate,
  };
}

export function signInRequest(payload, navigate) {
  return {
    type: actions.SIGN_IN_REQUEST,
    payload,
    navigate,
  };
}

export function signInGoogleRequest(payload, navigate) {
  return {
    type: actions.SIGN_IN_GOOGLE_REQUEST,
    payload,
    navigate,
  };
}

export function signInSuccess(payload) {
  return {
    type: actions.SIGN_IN_SUCCESS,
    payload,
  };
}

export function signUpRequest(payload) {
  return {
    type: actions.SIGN_UP_REQUEST,
    payload,
  };
}

export function signOutRequest(payload, navigate) {
  return {
    type: actions.SIGN_OUT_REQUEST,
    payload,
    navigate,
  };
}

export function signOutSuccess() {
  return {
    type: actions.SIGN_OUT_SUCCESS,
  };
}

export function currentUserListener(payload) {
  return {
    type: actions.CURRENT_USER_LISTENER,
    payload,
  };
}

export function cancelCurrentUserListener() {
  return {
    type: actions.CANCEL_CURRENT_USER_LISTENER,
  };
}

export function toggleLoading(payload) {
  return {
    type: actions.TOGGLE_LOADING,
    payload,
  };
}

export function showError(payload) {
  return {
    type: actions.SHOW_ERROR,
    payload,
  };
}

export function hideError() {
  return {
    type: actions.HIDE_ERROR,
  };
}

export function updateProfile(payload, callback) {
  return {
    type: actions.UPDATE_PROFILE,
    payload,
    callback,
  };
}

export function updateProfileSuccess(payload) {
  return {
    type: actions.UPDATE_PROFILE_SUCCESS,
    payload: {
      ...payload,
    },
  };
}

export function changePassword(payload, navigate) {
  return {
    type: actions.CHANGE_PASSWORD_REQUEST,
    payload,
    navigate,
  };
}

export function changePasswordSuccess(payload) {
  return {
    type: actions.CHANGE_PASSWORD_SUCCESS,
    payload,
  };
}

/* export function resetPasswordEmailRequest(payload) {
  return {
    type: actions.RESET_PASSWORD_EMAIL_REQUEST,
    payload,
  };
}

export function resetPasswordEmailSuccess(payload) {
  return {
    type: actions.RESET_PASSWORD_EMAIL_SUCCESS,
    payload,
  };
} */

export function pushNotification(payload) {
  return {
    type: actions.PUSH_NOTIFICATION,
    payload,
  };
}

export function seenNotification(payload) {
  return {
    type: actions.SEEN_NOTIFICATION,
    payload,
  };
}

export function notificationsSuccess(payload) {
  return {
    type: actions.NOTIFICATIONS_SUCCESS,
    payload,
  };
}

export function toggleNotificationsLoading(payload) {
  return {
    type: actions.TOGGLE_NOTIFICATIONS_LOADING,
    payload,
  };
}

export function listenNotifications() {
  return {
    type: actions.LISTEN_NOTIFICATIONS,
  };
}

export function cancelListenNotifications() {
  return {
    type: actions.CANCEL_LISTEN_NOTIFICATIONS,
  };
}

export function clearAllNotifications() {
  return {
    type: actions.CLEAR_ALL_NOTIFICATIONS,
  };
}

export function forgotPassword(payload) {
  return {
    type: actions.FORGOT_PASSWORD,
    payload,
  };
}

export function forgotPasswordUpdate(payload) {
  return {
    type: actions.FORGOT_PASSWORD_UPDATE,
    payload,
  };
}

export function verifyPasswordResetCode(payload) {
  return {
    type: actions.VERIFY_PASSWORD_RESET_CODE,
    payload,
  };
}

export function userActionUpdate(payload) {
  return {
    type: actions.USER_ACTION_UPDATE,
    payload,
  };
}

export function confirmPasswordReset(payload) {
  return {
    type: actions.CONFIRM_PASSWORD_RESET,
    payload,
  };
}

export function sendFeedback(payload) {
  return {
    type: actions.SEND_FEEDBACK,
    payload,
  };
}

export function feedbackUpdate(payload) {
  return {
    type: actions.FEEDBACK_UPDATE,
    payload,
  };
}

export function resendVerificationEmail() {
  return {
    type: actions.RESEND_VERIFICATION_EMAIL,
  };
}

export function verifyEmail(payload, navigate) {
  return {
    type: actions.VERIFY_EMAIL,
    payload,
    navigate,
  };
}

export function contact(payload) {
  return {
    type: actions.CONTACT,
    payload,
  };
}

export function signupUpdate(payload) {
  return {
    type: actions.SIGNUP_UPDATE,
    payload,
  };
}

export function sendProRequest(payload, callback) {
  return {
    type: actions.SEND_PRO_REQUEST,
    payload,
    callback,
  };
}

export function onboardingUpdate(payload) {
  return {
    type: actions.ONBOARDING_UPDATE,
    payload,
  };
}

export function toggleEmailPreference(payload) {
  return {
    type: actions.TOGGLE_EMAIL_PREFERENCE,
    payload,
  };
}

export function deleteUser(navigate) {
  return {
    type: actions.DELETE_USER,
    navigate,
  };
}

export function toggleReauth() {
  return {
    type: actions.TOGGLE_REAUTH,
  };
}

export function notificationsOpened() {
  return {
    type: actions.NOTIFICATIONS_OPENED,
  };
}

export function fetchCurrentIntegrationsRequest() {
  return {
    type: actions.FETCH_CURRENT_INTEGRATIONS_REQUEST,
  };
}

export function fetchCurrentIntegrationsSuccess(payload) {
  return {
    type: actions.FETCH_CURRENT_INTEGRATIONS_SUCCESS,
    payload,
  };
}

export function subscriptionsSuccess(payload) {
  return {
    type: actions.SUBSCRIPTIONS_SUCCESS,
    payload,
  };
}

export function cancelSubscription(callback) {
  return {
    type: actions.CANCEL_SUBSCRIPTION,
    callback,
  };
}

export function updateSubscription(payload, callback) {
  return {
    type: actions.UPDATE_SUBSCRIPTION,
    payload,
    callback,
  };
}

export function billingDetailsRequest() {
  return {
    type: actions.BILLING_DETAILS_REQUEST,
  };
}

export function billingDetailsSuccess(payload) {
  return {
    type: actions.BILLING_DETAILS_SUCCESS,
    payload,
  };
}

export function undoCancelSubscription() {
  return {
    type: actions.UNDO_CANCEL_SUBSCRIPTION,
  };
}

export function toggleNotificationSound() {
  return {
    type: actions.TOGGLE_NOTIFICATION_SOUND,
  };
}

export function resendEmailChangeVerifyEmail(callback) {
  return {
    type: actions.RESEND_EMAIL_CHANGE_VERIFY_EMAIL,
    callback,
  };
}

export function cancelSubcriptionPendingUpdate(payload) {
  return {
    type: actions.CANCEL_SUBSCRIPTION_PENDING_UPDATE,
    payload,
  };
}
